import Immutable from 'immutable';

export const PORTAL_THEME_DEFAULT_BRAND_COLOR = '#61BEB2';
export const PORTAL_THEME_DEFAULT_CTA_COLOR = '#F18A41';
export const PORTAL_THEME_TEXT_COLOR = '#2a2a2c';

export const PORTAL_THEME_SCHEME = Immutable.fromJS({
  'brand-color': {
    default: '#61BEB2',
    input: 'color',
    weight: 1,
    label: 'Brand color',
  },
  'cta-color': {
    default: '#F18A41',
    input: 'color',
    weight: 2,
    label: 'CTA color',
  },
});
